<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="760px"
    custom-class="lease-ylw-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="150px"
      size="small"
      class="tenant-form"
    >
      <div class="lease-form-row">
        <div class="lease-form-col-full">
          <el-form-item label="承租方类型" prop="tenantType">
            <el-radio-group v-model="form.tenantType" :disabled="isEdit">
              <el-radio
                v-for="item in tenantTypeOptions"
                :key="item.value"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="承租方名称" prop="tenantName">
            <el-input
              v-model="form.tenantName"
              maxlength="100"
              clearable
              placeholder="请输入承租方名称"
              :disabled="isEdit"
            />
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input
              v-model="form.contactPhone"
              maxlength="11"
              clearable
              placeholder="请输入联系电话"
              :disabled="isEdit"
              @blur="onContactPhoneBlur"
            />
          </el-form-item>
        </div>
        <div v-if="!isEdit" class="lease-form-col">
          <el-form-item label="登录账号" prop="loginAccount">
            <el-input
              :value="loginAccountDisplay"
              disabled
              placeholder="由联系电话自动生成"
            />
          </el-form-item>
        </div>
        <div v-if="!isEdit" class="lease-form-col">
          <el-form-item label="登录密码" prop="loginPassword">
            <el-input
              v-model="form.loginPassword"
              :type="passwordVisible ? 'text' : 'password'"
              maxlength="50"
              :disabled="passwordDisabled"
              :placeholder="passwordPlaceholder"
              autocomplete="off"
            >
              <i
                v-show="!passwordDisabled"
                slot="suffix"
                class="el-input__icon el-icon-view tenant-pwd-eye"
                :class="{ 'is-masked': !passwordVisible }"
                :title="passwordVisible ? '隐藏密码' : '显示密码'"
                @click="togglePasswordVisible"
              />
            </el-input>
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="联系人" prop="contactName">
            <el-input
              v-model="form.contactName"
              maxlength="50"
              clearable
              placeholder="请输入联系人"
            />
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="联系人身份证" prop="contactIdCard">
            <el-input
              v-model="form.contactIdCard"
              maxlength="18"
              clearable
              placeholder="请输入联系人身份证号"
            />
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="联系人邮箱" prop="contactEmail">
            <el-input
              v-model="form.contactEmail"
              maxlength="100"
              clearable
              placeholder="请输入联系人邮箱"
            />
          </el-form-item>
        </div>
        <div v-if="!isIndividual" class="lease-form-col">
          <el-form-item label="简称" prop="shortName">
            <el-input
              v-model="form.shortName"
              maxlength="50"
              clearable
              placeholder="请输入简称"
            />
          </el-form-item>
        </div>
        <div v-if="!isIndividual" class="lease-form-col">
          <el-form-item label="统一社会信用代码" prop="creditCode">
            <el-input
              v-model="form.creditCode"
              maxlength="32"
              clearable
              placeholder="请输入统一社会信用代码"
            />
          </el-form-item>
        </div>
        <div v-if="!isIndividual" class="lease-form-col">
          <el-form-item label="法人代表" prop="legalPerson">
            <el-input
              v-model="form.legalPerson"
              maxlength="50"
              clearable
              placeholder="请输入法人代表"
            />
          </el-form-item>
        </div>
        <div v-if="!isIndividual" class="lease-form-col">
          <el-form-item label="法人电话" prop="legalPhone">
            <el-input
              v-model="form.legalPhone"
              maxlength="11"
              clearable
              placeholder="请输入法人电话"
            />
          </el-form-item>
        </div>
        <div class="lease-form-col-full">
          <el-form-item label="地址" prop="address">
            <el-input
              v-model="form.address"
              maxlength="200"
              clearable
              placeholder="请输入地址"
            />
          </el-form-item>
        </div>
        <div v-if="!isIndividual" class="lease-form-col">
          <el-form-item label="开户银行" prop="bankName">
            <el-input
              v-model="form.bankName"
              maxlength="100"
              clearable
              placeholder="请输入开户银行"
            />
          </el-form-item>
        </div>
        <div v-if="!isIndividual" class="lease-form-col">
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input
              v-model="form.bankAccount"
              maxlength="50"
              clearable
              placeholder="请输入银行账号"
            />
          </el-form-item>
        </div>
        <div class="lease-form-col-full">
          <el-form-item label="附件" prop="attachmentUrl">
            <LeaseFileUpload
              v-model="form.attachmentUrl"
              :limit="5"
              :max-size-mb="10"
              tip="单个文件大小不超过10M（资产证明附加或其他所需附加）"
            />
          </el-form-item>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  addTenant,
  editTenant,
  getTenant,
  checkTenantLoginPhone,
  leaseRequestError
} from "@/service/fishPondLease.js";
import {
  TenantType,
  TenantTypeOptions
} from "@/service/fishPondLeaseEnums.js";
import LeaseFileUpload from "@/components/fishPondLease/common/LeaseFileUpload.vue";

var MOBILE_REG = /^1[3-9]\d{9}$/;
var LOGIN_ACCOUNT_PREFIX = "NX";
var LOGIN_PASSWORD_PREFIX = "nx";

function buildLoginAccount(phone) {
  var p = (phone || "").trim();
  return p ? LOGIN_ACCOUNT_PREFIX + p : "";
}

function buildLoginPassword(phone) {
  var p = (phone || "").trim();
  return p ? LOGIN_PASSWORD_PREFIX + p : "";
}

function createEmptyForm() {
  return {
    id: "",
    tenantName: "",
    tenantType: TenantType.Enterprise,
    shortName: "",
    creditCode: "",
    legalPerson: "",
    legalPhone: "",
    contactName: "",
    contactPhone: "",
    loginAccount: "",
    contactIdCard: "",
    contactEmail: "",
    address: "",
    bankName: "",
    bankAccount: "",
    attachmentUrl: "",
    loginPassword: ""
  };
}

export default {
  name: "TenantFormDialog",
  components: { LeaseFileUpload },
  data: function() {
    var self = this;
    var validateMobile = function(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (!MOBILE_REG.test(value)) {
        callback(new Error("请输入正确的手机号"));
        return;
      }
      callback();
    };
    var validateContactPhone = function(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入联系电话"));
        return;
      }
      if (!MOBILE_REG.test(value)) {
        callback(new Error("请输入正确的手机号"));
        return;
      }
      callback();
    };
    var validateLoginPassword = function(rule, value, callback) {
      if (self.isEdit) {
        callback();
        return;
      }
      if (self.phoneRegistered) {
        callback();
        return;
      }
      if (!value) {
        callback(new Error("请输入登录密码"));
        return;
      }
      callback();
    };
    return {
      visible: false,
      saving: false,
      isEdit: false,
      phoneRegistered: false,
      checkingPhone: false,
      passwordVisible: true,
      tenantTypeOptions: TenantTypeOptions,
      form: createEmptyForm(),
      rules: {
        tenantName: [
          { required: true, message: "请输入承租方名称", trigger: "blur" }
        ],
        tenantType: [
          { required: true, message: "请选择承租方类型", trigger: "change" }
        ],
        contactPhone: [
          { required: true, validator: validateContactPhone, trigger: "blur" }
        ],
        contactName: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        contactIdCard: [
          { required: true, message: "请输入联系人身份证号", trigger: "blur" }
        ],
        legalPhone: [{ validator: validateMobile, trigger: "blur" }],
        loginPassword: [{ validator: validateLoginPassword, trigger: "blur" }]
      }
    };
  },
  computed: {
    dialogTitle: function() {
      return this.isEdit ? "编辑承租方" : "新增承租方";
    },
    isIndividual: function() {
      return Number(this.form.tenantType) === TenantType.Individual;
    },
    passwordDisabled: function() {
      if (this.isEdit) return false;
      return this.phoneRegistered;
    },
    passwordPlaceholder: function() {
      if (this.isEdit) return "不修改请留空";
      if (this.phoneRegistered) return "已注册";
      return "请输入登录密码";
    },
    /** 已注册时提示用原账号登录；未注册显示 NX+联系电话 */
    loginAccountDisplay: function() {
      if (!this.isEdit && this.phoneRegistered) {
        return "用原账号登录";
      }
      return this.form.loginAccount || "";
    }
  },
  watch: {
    "form.contactPhone": function(val, oldVal) {
      if (this.isEdit) return;
      this.form.loginAccount = buildLoginAccount(val);
      // 电话变更后先重置注册态，等 blur 再校验
      this.phoneRegistered = false;
      // 未手改时，密码跟着联系电话走，默认 nx+手机号
      var prevDefault = buildLoginPassword(oldVal);
      var current = this.form.loginPassword || "";
      if (!current || current === prevDefault) {
        this.form.loginPassword = buildLoginPassword(val);
      }
    }
  },
  methods: {
    openAdd: function() {
      this.isEdit = false;
      this.phoneRegistered = false;
      this.passwordVisible = true;
      this.form = createEmptyForm();
      this.visible = true;
      this.$nextTick(
        function() {
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
        }.bind(this)
      );
    },
    openEdit: function(row) {
      var self = this;
      if (!row || !row.id) {
        this.$message.warning("缺少承租方信息");
        return;
      }
      this.isEdit = true;
      this.phoneRegistered = false;
      this.visible = true;
      this.form = createEmptyForm();
      getTenant(row.id)
        .then(function(res) {
          var data = (res && res.data) || {};
          var phone = data.contactPhone || "";
          self.form = {
            id: data.id,
            tenantName: data.tenantName || "",
            tenantType: data.tenantType || TenantType.Enterprise,
            shortName: data.shortName || "",
            creditCode: data.creditCode || "",
            legalPerson: data.legalPerson || "",
            legalPhone: data.legalPhone || "",
            contactName: data.contactName || "",
            contactPhone: phone,
            loginAccount: data.loginAccount || buildLoginAccount(phone),
            contactIdCard: data.contactIdCard || "",
            contactEmail: data.contactEmail || "",
            address: data.address || "",
            bankName: data.bankName || "",
            bankAccount: data.bankAccount || "",
            attachmentUrl: data.attachmentUrl || "",
            loginPassword: ""
          };
          self.$nextTick(function() {
            if (self.$refs.form) {
              self.$refs.form.clearValidate();
            }
          });
        })
        .catch(function(e) {
          self.$message.error(leaseRequestError(e));
          self.visible = false;
        });
    },
    handleClose: function() {
      this.saving = false;
      this.checkingPhone = false;
      this.phoneRegistered = false;
      this.passwordVisible = true;
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    togglePasswordVisible: function() {
      if (this.passwordDisabled) return;
      this.passwordVisible = !this.passwordVisible;
    },
    onContactPhoneBlur: function() {
      var self = this;
      if (this.isEdit) return;
      var phone = (this.form.contactPhone || "").trim();
      this.form.loginAccount = buildLoginAccount(phone);
      if (!MOBILE_REG.test(phone)) {
        this.phoneRegistered = false;
        return;
      }
      this.checkingPhone = true;
      checkTenantLoginPhone(phone)
        .then(function(res) {
          var data = (res && res.data) || {};
          self.phoneRegistered = !!data.exists;
          if (data.loginAccount) {
            self.form.loginAccount = data.loginAccount;
          }
          if (self.phoneRegistered) {
            self.form.loginPassword = "";
          }
          // 命中当前企业导入暂存时带出表单，供用户编辑确认
          var draft = data.importDraft;
          if (draft) {
            self.applyImportDraft(draft);
            self.$message.success("已带出导入暂存信息，请确认后保存");
          }
          self.$nextTick(function() {
            if (self.$refs.form) {
              self.$refs.form.validateField("loginPassword");
            }
          });
        })
        .catch(function(e) {
          self.phoneRegistered = false;
          self.$message.error(leaseRequestError(e));
        })
        .then(function() {
          self.checkingPhone = false;
        });
    },
    applyImportDraft: function(draft) {
      if (!draft) return;
      if (draft.tenantName) this.form.tenantName = draft.tenantName;
      if (draft.shortName != null) this.form.shortName = draft.shortName || "";
      if (draft.creditCode != null) this.form.creditCode = draft.creditCode || "";
      if (draft.legalPerson != null) this.form.legalPerson = draft.legalPerson || "";
      if (draft.legalPhone != null) this.form.legalPhone = draft.legalPhone || "";
      if (draft.contactName != null) this.form.contactName = draft.contactName || "";
      if (draft.contactIdCard != null) {
        this.form.contactIdCard = draft.contactIdCard || "";
      }
      if (draft.contactEmail != null) this.form.contactEmail = draft.contactEmail || "";
      if (draft.address != null) this.form.address = draft.address || "";
      if (draft.bankName != null) this.form.bankName = draft.bankName || "";
      if (draft.bankAccount != null) this.form.bankAccount = draft.bankAccount || "";
      if (draft.contactPhone) {
        this.form.loginAccount = buildLoginAccount(draft.contactPhone);
      }
      // 仅未注册时带出密码；没有暂存密码则保持 nx+手机号
      if (!this.phoneRegistered && draft.loginPassword) {
        this.form.loginPassword = draft.loginPassword;
      } else if (!this.phoneRegistered && !this.form.loginPassword) {
        this.form.loginPassword = buildLoginPassword(this.form.contactPhone);
      }
    },
    buildPayload: function() {
      var payload = {
        tenantName: (this.form.tenantName || "").trim(),
        tenantType: this.form.tenantType,
        contactName: (this.form.contactName || "").trim(),
        contactPhone: (this.form.contactPhone || "").trim(),
        contactIdCard: (this.form.contactIdCard || "").trim(),
        contactEmail: this.form.contactEmail || "",
        address: this.form.address || "",
        attachmentUrl: this.form.attachmentUrl || ""
      };
      if (!this.isIndividual) {
        payload.shortName = this.form.shortName || "";
        payload.creditCode = this.form.creditCode || "";
        payload.legalPerson = this.form.legalPerson || "";
        payload.legalPhone = this.form.legalPhone || "";
        payload.bankName = this.form.bankName || "";
        payload.bankAccount = this.form.bankAccount || "";
      } else {
        payload.shortName = "";
        payload.creditCode = "";
        payload.legalPerson = "";
        payload.legalPhone = "";
        payload.bankName = "";
        payload.bankAccount = "";
      }
      if (this.isEdit) {
        payload.id = this.form.id;
      } else if (!this.phoneRegistered) {
        payload.loginPassword = this.form.loginPassword || "";
      }
      return payload;
    },
    submit: function() {
      var self = this;
      this.$refs.form.validate(function(valid) {
        if (!valid) return;
        if (!self.isEdit && self.checkingPhone) {
          self.$message.warning("正在校验联系电话，请稍候");
          return;
        }
        var payload = self.buildPayload();
        self.saving = true;
        var req = self.isEdit ? editTenant(payload) : addTenant(payload);
        req
          .then(function() {
            self.$message.success(self.isEdit ? "保存成功" : "新增成功");
            self.visible = false;
            self.$emit("success");
          })
          .catch(function(e) {
            self.$message.error(leaseRequestError(e));
          })
          .then(function() {
            self.saving = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.tenant-pwd-eye {
  cursor: pointer;
  color: #c0c4cc;
  position: relative;
}
.tenant-pwd-eye:hover {
  color: #909399;
}
.tenant-pwd-eye.is-masked::after {
  content: "";
  position: absolute;
  left: 5px;
  top: 50%;
  width: 14px;
  height: 1px;
  background: currentColor;
  transform: rotate(-45deg);
}
.tenant-form >>> input::-ms-reveal,
.tenant-form >>> input::-ms-clear {
  display: none;
}
</style>
